var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "icons-version-selector" },
    [
      _c(
        "wa-select-custom",
        {
          attrs: {
            label: "Choose a version of Font Awesome",
            "is-minimal": "",
          },
          on: { change: (value) => _vm.resolveIconRoute(value) },
        },
        [
          _c(
            "template",
            { slot: "options" },
            _vm._l(_vm.allVersions, function (version) {
              return _c(
                "option",
                {
                  key: version,
                  domProps: { selected: _vm.activeVersion === version },
                },
                [_vm._v("\n        " + _vm._s(version) + "\n      ")]
              )
            }),
            0
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }